<template>
  <ck-tab
    v-model="currentTab"
    :items="tabItems"
    layout="button"
    class="application-tab"
  />
</template>

<script>
import CkTab from '~/components/kit/CkTab'

export default {
  components: {
    CkTab
  },
  data() {
    return {
      tabItems: [
        {
          id: 'service',
          text: this.$t('service')
        },
        {
          id: 'monitoring',
          text: this.$t('monitoring')
        }
      ]
    }
  },
  computed: {
    hasHemPackage() {
      return this.$storage.getUniversal('hasHemPackage')
    },
    currentInstallation() {
      return this.$storage.getUniversal('current-installation')
    },
    availablePackages() {
      return this.$store.state.package.availablePackages
    },
    currentTab: {
      get() {
        return this.page === 'overview'
          ? this.tabItems[0].id
          : this.tabItems[1].id
      },
      set(value) {
        this.setCurrentTab(value)
      }
    },
    page() {
      return this.$route.name
    }
  },
  methods: {
    async setCurrentTab(value) {
      let route = { name: 'overview' } // Default route

      if (value === 'monitoring') {
        if (this.hasHemPackage && this.currentInstallation) {
          route = { name: 'energy' }
        } else {
          route = await this.getMonitoringRoute()
        }
      }

      this.$router.push(route)
    },

    async getMonitoringRoute() {
      const hemPackages = this.availablePackages.filter((p) => p.hems)
      await this.ensurePackageInStore()

      if (hemPackages.length > 1) {
        return {
          name: 'overview-installationId-packages',
          params: {
            installationId: this.currentInstallation.id
          },
          query: { hems: true }
        }
      } else if (hemPackages.length === 1) {
        return {
          name: 'overview-installationId-packageId',
          params: {
            installationId: this.currentInstallation.id,
            packageId: hemPackages[0].id
          }
        }
      } else {
        return {
          name: 'overview-installationId-packages',
          params: {
            installationId: this.currentInstallation.id
          }
        }
      }
    },

    async ensurePackageInStore() {
      const currentPackage = await this.$store.dispatch(
        'package/getPackage',
        this.$route.params.packageId
      )

      if (!currentPackage) {
        const packages = await this.$store.dispatch(
          'package/getPackages',
          this.currentInstallation.id
        )
        const allPackages = packages.free.concat(
          packages.paid,
          packages.cashback
        )
        await this.$store.dispatch('package/setPackages', allPackages)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import (reference) '~@/assets/less/main.less';

.application-tab {
  position: relative;
  padding-left: @space-s;

  ::v-deep > div {
    position: absolute;
    top: 115px;
  }
}
</style>
